/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-check': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" _fill="#000" fill-rule="evenodd" d="M10.121 1.32a1.1 1.1 0 011.878.764c.006.29-.104.57-.303.78l-5.869 7.335a1.114 1.114 0 01-1.22.272 1.093 1.093 0 01-.368-.243L.351 6.338A1.109 1.109 0 010 5.551a1.114 1.114 0 01.69-1.042 1.104 1.104 0 011.219.271l3.079 3.077 5.105-6.505.03-.032h-.002z" clip-rule="evenodd"/>'
  }
})
